<template>
	<div class="product-modal _modal">
		<div class="_modal-overlay" @click.self="$emit('close')"></div>
		<div class="product-modal__inner _modal-inner">
			<div
				class="product-modal__close _modal-close"
				@click="$emit('close')"
			></div>

			<div v-if="loading" class="product-modal__loading">
				{{ $t('Loading') }}...
			</div>

			<div v-else-if="error" class="product-modal__error">
				{{ $t(`${error}`) }}
			</div>
			<div v-else-if="product" class="product-modal__content">
				<div class="product-modal__wrapper">
					<div class="product-modal__image _ibg-contain">
						<img :src="imgDomain + product.img_url" />
					</div>
					<div class="product-modal__bg _ibg">
						<img src="@/assets/images/bg/yellow-blur.png" />
					</div>
				</div>
				<div class="product-modal__name _h2">
					{{ getSkinName(product.title) }}
				</div>
				<div v-if="product.old_price" class="product-modal__oldPrice">
					<div class="product-modal__oldPrice-number _md">
						{{ product.old_price }} {{ currencySymbol }}
					</div>
					<!--<div class="product-modal__oldPrice-icon _ibg-contain">
						<img src="@/assets/images/icons/coin.svg" />
					</div>-->
				</div>
				<div class="product-modal__bottom">
					<div class="product-modal__column">
						<div class="product-modal__meta">
							<div class="product-modal__meta-name">
								{{ $t('Type') }}:
							</div>
							<div class="product-modal__meta-value">
								{{ product.type }}
							</div>
						</div>
						<div class="product-modal__meta">
							<div class="product-modal__meta-name">
								{{ $t('Quality') }}:
							</div>
							<div class="product-modal__meta-value">
								{{ product.quality }}
							</div>
						</div>
					</div>
					<div class="product-modal__column">
						<div class="product-modal__price">
							<div class="product-modal__price-number">
								{{ product.price }}
								{{ currencySymbol }}
							</div>
							<!--<div class="product-modal__price-icon _ibg-contain">
								<img src="@/assets/images/icons/coin.svg" />
							</div>-->
						</div>
						<!--<div class="product-modal__real">
							<div class="product-modal__real-number">
								{{ product.price }}
							</div>
							<div class="product-modal__real-sumbol">
								{{ currencyCode }}
							</div>
						</div>-->
					</div>
				</div>
				<BaseButton
					class="product-modal__button _btn-primary"
					@click="addToCart(product)"
					>{{ $t('Add to cart') }}</BaseButton
				>
			</div>
			<div v-else class="product-modal__no-product">
				{{ $t('Product not found') }}
			</div>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'ProductModal',
	components: { BaseButton },
	props: {
		id: { type: String, required: true },
		isAuth: { type: Boolean, required: true },
		chosenItem: String,
	},
	data() {
		return {
			product: null,
			loading: true,
			error: false,
			imgDomain: '',
		};
	},
	computed: {
		...mapGetters('app', ['currencyCode']),
		...mapGetters('cart', ['cartContents']),
		...mapGetters('app', ['currencySymbol']),
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
		this.fetchProduct();
	},
	methods: {
		async fetchProduct() {
			this.loading = true;
			this.error = false;

			try {
				const res = await this.$http.get(
					`${process.env.VUE_APP_API}items/${this.id}`,
					{
						params: {
							currency: this.currencyCode,
						},
					}
				);
				this.product = res.data.payload;
			} catch (e) {
				this.error = e.response.data.message;
			} finally {
				this.loading = false;
			}
		},
		getSkinName(desc) {
			if (!desc) return '';
			const match = desc.match(/\|\s*([^()]+)\(/);
			return match ? match[1].trim() : '';
		},
		addToCart(item) {
			if (this.isAuth) {
				const itemAlreadyInCart = this.cartContents.some(
					(cartItem) => cartItem.item_id === item.id
				);

				if (itemAlreadyInCart) {
					this.$toast.info(this.$t('This item is already in your cart.'));
					return;
				}
				this.$emit('addToCart', item);
				this.$toast.info(this.$t('Item added to your cart.'));
			} else {
				this.$emit('close');
				this.$emit('openLoginModal');
				return;
			}
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.product-modal {
	&__inner {
		max-width: 466px;
	}
	&__close {
	}
	&__loading,
	&__error,
	&__no-product {
		font-family: var(--font-family-inter);
		font-size: 16px;
		line-height: 120%;
		font-weight: 500;
		display: block;
		text-align: center;
	}
	&__loading {
		color: var(--primary-color);
	}
	&__error {
		color: var(--error-color);
	}
	&__content {
	}
	&__wrapper {
		position: relative;
	}
	&__bg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: -1;
		max-width: 260px;
		width: 100%;
		padding-bottom: 60%;
	}
	&__image {
		max-width: 230px;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		padding-bottom: 40%;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 30, 15);
		}
	}

	&__name {
		font-family: var(--font-family-inter);
		font-weight: 700;
		line-height: 150%;
		@include adaptiveValue('font-size', 32, 22);
		color: var(--primary-color);
		display: block;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
	}
	&__bottom {
		display: flex;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
	}
	&__column {
		flex: 0 1 50%;
	}
	&__meta {
		display: flex;
		gap: 6px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 16, 8);
		}
		&-name,
		&-value {
			font-size: 12px;
			font-weight: 500;
			line-height: 150%;
			font-family: var(--font-family-inter);
		}
		&-name {
			color: var(--secondary-color);
		}
		&-value {
			color: var(--primary-color);
		}
	}
	&__price {
		display: flex;
		justify-content: flex-end;
		@include adaptiveValue('gap', 8, 6);
		&-number {
			@include adaptiveValue('font-size', 28, 20);
			font-weight: 700;
			font-family: var(--font-family-inter);
			line-height: 120%;
			color: var(--primary-color);
		}
		&-icon {
			@include adaptiveValue('min-width', 22, 18);
			@include adaptiveValue('height', 22, 18);
		}
	}
	&__real {
		display: flex;
		justify-content: flex-end;
		gap: 6px;
		font-size: 10px;
		color: var(--secondary-color);
		font-weight: 500;
		font-family: var(--font-family-inter);
		&-number {
		}
		&-sumbol {
		}
	}
	&__oldPrice {
		display: flex;
		align-items: center;
		gap: 6px;
		justify-content: flex-end;
		opacity: 0.7;
		text-decoration: line-through;
		&:not(:last-child) {
			margin-bottom: 5px;
		}
		&-number {
			font-family: var(--font-family-inter);
			font-size: 14px !important;
		}
		&-icon {
			min-width: 12px;
			height: 12px;
		}
	}
	&__button {
		@include adaptiveValue('min-height', 40, 38);
		max-width: 224px;
		width: 100%;
		margin: 0 auto;
	}
}
</style>
